import React from 'react';
import { Link } from 'react-router-dom';
import { BiSolidLike } from "react-icons/bi";
import { HiArrowLongRight } from "react-icons/hi2"; // Adding a sleek arrow icon

function TrendingPostCard({ post }) {
  return (
    <Link 
      to={`/post/${post._id}`} 
      className="group block h-full bg-white rounded-2xl border border-gray-100 p-6 transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.1)] hover:border-blue-100 relative overflow-hidden"
    >
      {/* Subtle Background Accent */}
      <div className="absolute top-0 left-0 w-1 h-0 bg-blue-500 transition-all duration-300 group-hover:h-full" />

      <div className="flex flex-col h-full justify-between space-y-4">
        
        <div>
          {/* Top Row: Company & Status */}
          <div className="flex items-center justify-between mb-4">
            <span className="text-[10px] font-bold uppercase tracking-widest bg-gray-50 text-gray-500 px-3 py-1 rounded-full border border-gray-100">
              {post.company}
            </span>
            {post.status === 'Selected' && (
              <span className="text-[10px] font-bold uppercase bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full border border-emerald-100">
                Selected
              </span>
            )}
          </div>

          {/* Title/Caption */}
          <h2 className="text-xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-200 line-clamp-2 leading-tight">
            {post.caption}
          </h2>

          {/* Content Excerpt */}
          <div 
            className='mt-3 text-gray-500 text-sm line-clamp-3 leading-relaxed'
            dangerouslySetInnerHTML={{ __html: post.content }} 
          />
        </div>

        {/* Footer: Likes & CTA */}
        <div className="pt-4 border-t border-gray-50 flex items-center justify-between">
          <div className="flex items-center gap-1 text-orange-500 font-medium">
            <BiSolidLike size={18} />
            <span className="text-sm">{post.likesCount ?? 0}</span>
          </div>

          <div className="flex items-center text-blue-600 font-semibold text-sm opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
            Read More <HiArrowLongRight size={20} className="ml-1" />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default TrendingPostCard;